import React, { useState, useEffect } from 'react';
import { ConversionTable, GradientInput, InputLabel, InputWrapper, InputGroup, TabContent } from '../../pages/tools/ToolsPage.components';
import { lengthConversionFactors, formatNumber } from './conversionUtils';

const LengthConverter: React.FC = () => {
    const [meter, setMeter] = useState('1');
    const [inches, setInches] = useState('');
    const [feet, setFeet] = useState('');
    const [nauticalMiles, setNauticalMiles] = useState('');

    // Initialize with default value on mount
    useEffect(() => {
        const defaultValue = 1;
        setInches(formatNumber(defaultValue * lengthConversionFactors.inches, 3));
        setFeet(formatNumber(defaultValue * lengthConversionFactors.feet, 3));
        setNauticalMiles(formatNumber(defaultValue * lengthConversionFactors.nauticalMiles, 6));
    }, []);

    const handleMeterChange = (value: string) => {
        setMeter(value);
        if (value === '') {
            setInches('');
            setFeet('');
            setNauticalMiles('');
            return;
        }
        const numValue = parseFloat(value);
        if (!isNaN(numValue)) {
            setInches(formatNumber(numValue * lengthConversionFactors.inches, 3));
            setFeet(formatNumber(numValue * lengthConversionFactors.feet, 3));
            setNauticalMiles(formatNumber(numValue * lengthConversionFactors.nauticalMiles, 6));
        }
    };

    const handleInchesChange = (value: string) => {
        setInches(value);
        if (value === '') {
            setMeter('');
            setFeet('');
            setNauticalMiles('');
            return;
        }
        const numValue = parseFloat(value);
        if (!isNaN(numValue)) {
            const baseValue = numValue / lengthConversionFactors.inches;
            setMeter(formatNumber(baseValue, 3));
            setFeet(formatNumber(baseValue * lengthConversionFactors.feet, 3));
            setNauticalMiles(formatNumber(baseValue * lengthConversionFactors.nauticalMiles, 6));
        }
    };

    const handleFeetChange = (value: string) => {
        setFeet(value);
        if (value === '') {
            setMeter('');
            setInches('');
            setNauticalMiles('');
            return;
        }
        const numValue = parseFloat(value);
        if (!isNaN(numValue)) {
            const baseValue = numValue / lengthConversionFactors.feet;
            setMeter(formatNumber(baseValue, 3));
            setInches(formatNumber(baseValue * lengthConversionFactors.inches, 3));
            setNauticalMiles(formatNumber(baseValue * lengthConversionFactors.nauticalMiles, 6));
        }
    };

    const handleNauticalMilesChange = (value: string) => {
        setNauticalMiles(value);
        if (value === '') {
            setMeter('');
            setInches('');
            setFeet('');
            return;
        }
        const numValue = parseFloat(value);
        if (!isNaN(numValue)) {
            const baseValue = numValue / lengthConversionFactors.nauticalMiles;
            setMeter(formatNumber(baseValue, 3));
            setInches(formatNumber(baseValue * lengthConversionFactors.inches, 3));
            setFeet(formatNumber(baseValue * lengthConversionFactors.feet, 3));
        }
    };

    return (
        <TabContent>
            <ConversionTable>
                <thead>
                    <tr>
                        <th>Length</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Meter:</td>
                        <td>
                            <InputWrapper>
                                <InputGroup>
                                    <GradientInput id="meter" type="text" value={meter} onChange={(e) => handleMeterChange(e.target.value)} />
                                    <InputLabel htmlFor="meter">m</InputLabel>
                                </InputGroup>
                            </InputWrapper>
                        </td>
                    </tr>
                    <tr>
                        <td>Inches:</td>
                        <td>
                            <InputWrapper>
                                <InputGroup>
                                    <GradientInput id="inches" type="text" value={inches} onChange={(e) => handleInchesChange(e.target.value)} />
                                    <InputLabel htmlFor="inches">&quot;</InputLabel>
                                </InputGroup>
                            </InputWrapper>
                        </td>
                    </tr>
                    <tr>
                        <td>Feet:</td>
                        <td>
                            <InputWrapper>
                                <InputGroup>
                                    <GradientInput id="feet" type="text" value={feet} onChange={(e) => handleFeetChange(e.target.value)} />
                                    <InputLabel htmlFor="feet">ft</InputLabel>
                                </InputGroup>
                            </InputWrapper>
                        </td>
                    </tr>
                    <tr>
                        <td>Nautical Miles:</td>
                        <td>
                            <InputWrapper>
                                <InputGroup>
                                    <GradientInput
                                        id="nauticalmiles"
                                        type="text"
                                        value={nauticalMiles}
                                        onChange={(e) => handleNauticalMilesChange(e.target.value)}
                                    />
                                    <InputLabel htmlFor="nauticalmiles">nmi</InputLabel>
                                </InputGroup>
                            </InputWrapper>
                        </td>
                    </tr>
                </tbody>
            </ConversionTable>
        </TabContent>
    );
};

export default LengthConverter;
